import { PageHeader } from "@/components/PageHeader";

export default function DowntimeRegistrationPage() {
  return (
    <div className="flex flex-col bg-background">
      <PageHeader title="비가동등록" />

      <main className="flex-1 p-6">
        <div className="container mx-auto">
          <p className="text-gray-600 dark:text-gray-400">
            This is downtime-registration page
          </p>
        </div>
      </main>
    </div>
  );
}
